import React from "react";
import InfoBox from "../../system/InfoBox";
import { ResponsiveBar } from "@nivo/bar";
import dayjs from "dayjs";

class DataContainer {
  constructor(dayString) {
    this.day = dayString;
    this.values = { negative: 0, neutral: 0, positive: 0 };
  }

  setValue(sentiment, count) {
    switch (sentiment.toLowerCase()) {
      case "negative":
        this.setNegative(count);
        break;
      case "neutral":
        this.setNeutral(count);
        break;
      case "positive":
        this.setPositive(count);
        break;
      default:
        break;
    }
  }
  setNegative(value) {
    this.values.negative = value;
  }
  setNeutral(value) {
    this.values.neutral = value;
  }
  setPositive(value) {
    this.values.positive = value;
  }

  toObject() {
    return {
      date: this.day,
      negative: parseInt(this.values.negative),
      negativeColor: "hsl(107, 70%, 50%",
      neutral: parseInt(this.values.neutral),
      neutralColor: "hsl(222, 70%, 50%)",
      positive: parseInt(this.values.positive),
      positiveColor: "hsl(143, 70%, 50%)",
    };
  }
}
export default function EntityHistoryResult(props) {
  function transformData() {
    //the incoming data is in the following format:
    /**
     * 	0: {sentiment: "NEGATIVE", count: "9", timestamp: "1592842242000"}
     *  1: {sentiment: "NEGATIVE", count: "9", timestamp: "1592842253000"}
     *  2: {sentiment: "NEUTRAL", count: "9", timestamp: "1592842271000"}
     *  and we will convert it to the following format:
     * [
     *  {
     *   date: "03/27/2020",
     *   "negative": 9,
     *   "negativeColor": "hsl(107, 70%, 50%"),
     *   "neutral": 0,
     *   "neutralColor": "hsl(222, 70%, 50%"),
     *   "positive": 3,
     *   "positiveColor": "hsl(143, 50%, 50%"),
     * },
     * {
     *   date: "03/28/2020",
     *   ....
     * },
     * ..
     * ]
     *
     */
    const dataMap = new Map();
    props.result.Items.forEach((item) => {
      const day = dayjs(parseInt(item.timestamp)).format("YYYY-MM-DD");
      let dataContainer = dataMap.get(day);
      if (dataContainer) {
        dataContainer.setValue(item.sentiment, item.count);
      } else {
        dataContainer = new DataContainer(day);
        dataContainer.setValue(item.sentiment, item.count);
        dataMap.set(day, dataContainer);
      }
    });

    return dataMap;
  }

  if (props.result && props.result.Items && props.result.Items.length) {
    const dataMap = transformData();
    const data = Array.from(dataMap.values()).map(function (v) {
      return v.toObject();
    });
    return (
      <div style={{ height: "400px" }}>
        <ResponsiveBar
          data={data}
          keys={["neutral", "negative", "positive"]}
          indexBy="date"
          margin={{ top: 50, right: 130, bottom: 50, left: 60 }}
          padding={0.3}
          colors={{ scheme: "nivo" }}
          defs={[
            {
              id: "dots",
              type: "patternDots",
              background: "inherit",
              color: "#38bcb2",
              size: 4,
              padding: 1,
              stagger: true,
            },
            {
              id: "lines",
              type: "patternLines",
              background: "inherit",
              color: "#eed312",
              rotation: -45,
              lineWidth: 6,
              spacing: 10,
            },
          ]}
          fill={[
            {
              match: {
                id: "negative",
              },
              id: "dots",
            },
            {
              match: {
                id: "positive",
              },
              id: "lines",
            },
          ]}
          borderColor={{ from: "color", modifiers: [["darker", 1.6]] }}
          axisTop={null}
          axisRight={null}
          axisBottom={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: "date",
            legendPosition: "middle",
            legendOffset: 32,
          }}
          axisLeft={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: "sentiment",
            legendPosition: "middle",
            legendOffset: -40,
          }}
          labelSkipWidth={12}
          labelSkipHeight={12}
          labelTextColor={{ from: "color", modifiers: [["darker", 1.6]] }}
          legends={[
            {
              dataFrom: "keys",
              anchor: "bottom-right",
              direction: "column",
              justify: false,
              translateX: 120,
              translateY: 0,
              itemsSpacing: 2,
              itemWidth: 100,
              itemHeight: 20,
              itemDirection: "left-to-right",
              itemOpacity: 0.85,
              symbolSize: 20,
              effects: [
                {
                  on: "hover",
                  style: {
                    itemOpacity: 1,
                  },
                },
              ],
            },
          ]}
          animate={true}
          motionStiffness={90}
          motionDamping={15}
        />
      </div>
    );
  } else {
    return (
      <InfoBox
        type="warning"
        message={`No history data found for the given time period for ${props.entity}`}
      />
    );
  }
}
